import _index from "./htm/index.js";
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const index_js_1 = __importDefault(_index);
exports.default = index_js_1.default;
//# sourceMappingURL=htm.js.map
export default exports;